module.exports = __webpack_public_path__ + "img/Blue_back.84bdc3bd.png";